import { createGlobalStyle } from 'styled-components';

 
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-color: #FEF5D0;
    font-family: 'Montserrat', sans-serif;
    font-family: 'Poppins', sans-serif;
    font-family: 'Quicksand', sans-serif;
  }
`;
 
export default GlobalStyle;

